/* eslint-disable no-restricted-syntax */
/* eslint-disable no-console */
/* eslint-disable no-continue */
/* eslint-disable no-await-in-loop */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import orderBy from 'lodash/orderBy';
import isEmpty from 'lodash/isEmpty';

import { useTranslation } from 'react-i18next';

// ui
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import InfoIcon from '@material-ui/icons/Info';
import IconButton from '@material-ui/core/IconButton';
import WarningIcon from '@material-ui/icons/Warning';

// style
import { styles, StyledBadge } from '../style';

const useStyles = makeStyles(styles);
const initPath = `/${process.env.REACT_APP_PATH}`;

export default function WarningList(props) {
  const { t } = useTranslation();
  const classes = useStyles();
  const {
    datas, handleDetailList, handleOpenLegend, mobilemode,
  } = props;

  const [damYellow, setDamYellow] = useState([]);

  const filterDamsByLowerRuleCurve = async (damDataList) => {
    const currentYear = new Date().getFullYear();
    const filteredResults = [];

    for (const dam of damDataList) {
      try {
        const damId = dam?.dam?.id;
        const damDateStr = dam?.dam_date;
        const damStorage = dam?.dam_storage;

        if (!damId || !damDateStr || damStorage === undefined) {
          console.error('ข้อมูลไม่ครบ:', dam);
          continue;
        }

        const apiUrl = `${process.env.REACT_APP_API_URL}/analyst/dam_yearly_graph?data_type=dam_storage&dam_id=${damId}&year=${currentYear}`;
        const response = await fetch(apiUrl);
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

        const apiData = await response.json();

        const lowerRuleCurve = apiData?.data?.lower_rule_curve;

        if (!lowerRuleCurve || lowerRuleCurve.length === 0) continue;

        const targetMonthDay = damDateStr.slice(5);
        const ruleForDay = lowerRuleCurve.find((rule) => rule.date.slice(5) === targetMonthDay);
        if (ruleForDay && damStorage < ruleForDay.value) {
          filteredResults.push(dam);
        }
      } catch (error) {
        console.error(`หา dam_id: ${dam?.dam?.id}`, error);
      }
    }
    return filteredResults;
  };

  useEffect(() => {
    const fetchData = async () => {
      if (datas?.yellow) {
        const result = await filterDamsByLowerRuleCurve(datas.yellow);
        setDamYellow(result);
      }
    };
    fetchData();
  }, [datas]);

  return (
    <Box className={mobilemode ? classes.boxViewMobile : classes.boxViewWarning}>
      <Box display="flex" justifyContent="flex-start">
        <Box>
          <Box display="flex" alignItems="center">
            <Box display="flex" className={classes.shapeCircle} alignItems="center" justifyContent="center">
              {!isEmpty(datas)
                ? (
                  <IconButton onClick={mobilemode ? null : handleDetailList(datas)}>
                    <StyledBadge
                      id="dam_detail"
                      badgeContent={6}
                      overlap="circular"
                      color="secondary"
                    >
                      <WarningIcon style={{ color: 'white' }} />
                    </StyledBadge>
                  </IconButton>
                ) : (
                  <StyledBadge
                    id="dam_detail"
                    badgeContent={6}
                    overlap="circular"
                    color="secondary"
                  >
                    <WarningIcon style={{ color: 'white' }} />
                  </StyledBadge>
                )}
            </Box>
            <Box id="dialog_dam" display="flex" alignItems="center">
              <Box pl={1}>
                <IconButton id="legend_dam" className={classes.btn} onClick={handleOpenLegend(t('เกณฑ์'), 'warning')}>
                  <InfoIcon type="button" style={{ fontSize: 13, color: '#777' }} />
                </IconButton>
              </Box>
              <Box px={1}>
                <Typography className={classes.titleBox}>
                  {t('เฝ้าระวังพื้นที่เสี่ยง')}
                </Typography>
              </Box>
              <Box>
                <Typography className={classes.timeBox}>
                  {datas.time}
                </Typography>
              </Box>
            </Box>
          </Box>
          <Box
            className={`${classes.listsBox}`}
          >
            <Grid id="dialog_Warning" container justifyContent="flex-start" spacing={1} className={classes.contentBox}>
              <Box display="block" width="100%" mb={1}>
                <Box>
                  <span style={{ color: '#F89408' }}>
                    <strong>
                      {t('น้ำป่าไหลหลาก (ทน)')}
                      {' '}
                      :
                    </strong>
                  </span>
                </Box>
                <Box display="flex" flexWrap="wrap" gridGap={4} mt={1}>
                  <Box style={{ color: '#000', backgroundColor: '#F89408', borderRadius: '4px', padding: '4px 8px', width: 'fit-content' }}>เชียงใหม่</Box>
                  <Box style={{ color: '#000', backgroundColor: '#F89408', borderRadius: '4px', padding: '4px 8px', width: 'fit-content' }}>เชียงราย</Box>
                  <Box style={{ color: '#000', backgroundColor: '#F89408', borderRadius: '4px', padding: '4px 8px', width: 'fit-content' }}>ลำปาง</Box>
                </Box>
              </Box>
              <Box width="100%" />
              <Box display="block" width="100%" mb={1}>
                <Box>
                  <span style={{ color: '#B02318' }}>
                    <strong>
                      {t('น้ำป่าไหลหลาก (ทน)')}
                      {' '}
                      :
                    </strong>
                  </span>
                </Box>
                <Box display="flex" flexWrap="wrap" gridGap={4} mt={1}>
                  <Box style={{ color: '#fff', textShadow: '1px 1px 1px #000', fontWeight: 500, backgroundColor: '#B02318', borderRadius: '4px', padding: '4px 8px', width: 'fit-content' }}>พังงา</Box>
                  <Box style={{ color: '#fff', textShadow: '1px 1px 1px #000', fontWeight: 500, backgroundColor: '#B02318', borderRadius: '4px', padding: '4px 8px', width: 'fit-content' }}>ตราด</Box>
                  <Box style={{ color: '#fff', textShadow: '1px 1px 1px #000', fontWeight: 500, backgroundColor: '#B02318', borderRadius: '4px', padding: '4px 8px', width: 'fit-content' }}>พะเยา</Box>
                </Box>
              </Box>
              <Box display="block" width="100%" mb={1}>
                <Box>
                  <span style={{ color: '#ff0000' }}>
                    <strong>
                      {t('น้ำล้นตลิ่ง (สนทช)')}
                      {' '}
                      :
                    </strong>
                  </span>
                </Box>
                <Box display="flex" flexWrap="wrap" gridGap={4} mt={1}>
                  <Box style={{ color: '#fff', textShadow: '1px 1px 1px #000', fontWeight: 500, backgroundColor: '#ff0000', borderRadius: '4px', padding: '4px 8px', width: 'fit-content' }}>กาญจนบุรี</Box>
                  <Box style={{ color: '#fff', textShadow: '1px 1px 1px #000', fontWeight: 500, backgroundColor: '#ff0000', borderRadius: '4px', padding: '4px 8px', width: 'fit-content' }}>ภูเก็ต</Box>
                  <Box style={{ color: '#fff', textShadow: '1px 1px 1px #000', fontWeight: 500, backgroundColor: '#ff0000', borderRadius: '4px', padding: '4px 8px', width: 'fit-content' }}>นครนายก</Box>
                  <Box style={{ color: '#fff', textShadow: '1px 1px 1px #000', fontWeight: 500, backgroundColor: '#ff0000', borderRadius: '4px', padding: '4px 8px', width: 'fit-content' }}>ปทุมธานี</Box>
                  <Box style={{ color: '#fff', textShadow: '1px 1px 1px #000', fontWeight: 500, backgroundColor: '#ff0000', borderRadius: '4px', padding: '4px 8px', width: 'fit-content' }}>นนทบุรี</Box>
                  <Box style={{ color: '#fff', textShadow: '1px 1px 1px #000', fontWeight: 500, backgroundColor: '#ff0000', borderRadius: '4px', padding: '4px 8px', width: 'fit-content' }}>ราชบุรี</Box>
                </Box>
              </Box>
            </Grid>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

WarningList.defaultProps = {
  mobilemode: false,
};

WarningList.propTypes = {
  datas: PropTypes.objectOf(Object).isRequired,
  handleDetailList: PropTypes.func.isRequired,
  handleOpenLegend: PropTypes.func.isRequired,
  mobilemode: PropTypes.bool,
};
